import { createFileRoute } from "@tanstack/react-router";
import { GarageRoadworthiness } from "@/features/settings/garage-settings";

export const Route = createFileRoute("/settings/roadworthiness")({
  component: GarageRoadworthiness,
});
